import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import ModalV4 from 'src/app/ui/modal/v4/v4';
import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll';
import Form from "./form";
import ModalV4HeaderWhite from "../../../app/ui/modal/v4/header-white/v4-header-white";
import ButtonSubmit2 from "../../gd-form/common/btn-submit/btn-submit-2";

module.exports = class ModalMeetingNote extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            title       : PropTypes.string,
            showAccess  : PropTypes.bool,
            note        : PropTypes.object,
            onCallback  : PropTypes.func
        })
    }

    componentDidMount() {
        this.submitButton.setForm(this.form.getForm())
    }

    render() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <ModalV4HeaderWhite height={60} onClose={this.closeModal} title={this.props.params.title}/>

                <div className="main-center">
                    <VScroll>
                        <Form ref           = {r => this.form = r}
                              note          = {this.props.params.note}
                              showAccess    = {this.props.params.showAccess}
                              onSubmit      = {this.props.params.onCallback}/>
                    </VScroll>
                </div>

                <div className="modal-submit">
                    <ButtonSubmit2 ref={r=>this.submitButton = r} label="Submit"/>
                </div>
            </div>
        )
    }
};